const DATE_OPTIONS = { day: '2-digit', month: 'short', year: 'numeric' };

// document_date is a plain YYYY-MM-DD string; build the Date from its parts
// so a timezone offset can never shift it to the previous/next day.
export function formatDocDate(iso) {
  if (!iso) return '';
  const [y, m, d] = String(iso).split('-').map(Number);
  if (!y || !m || !d) return String(iso);
  return new Date(y, m - 1, d).toLocaleDateString('en-GB', DATE_OPTIONS);
}

export function formatAdded(timestamp) {
  const date = new Date(timestamp);
  if (Number.isNaN(date.getTime())) return '';
  return date.toLocaleDateString('en-GB', DATE_OPTIONS);
}

export function formatBytes(bytes) {
  if (!Number.isFinite(bytes) || bytes < 0) return '';
  if (bytes < 1024) return `${bytes} B`;
  if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(0)} KB`;
  return `${(bytes / 1024 / 1024).toFixed(1)} MB`;
}
